import type React from 'react';

import { C } from './styles';

type CtaProps = { type?: string; text?: string; link?: string; style?: string; defaultText: string };

function getCtaLabel(type: string, text: string | undefined, defaultText: string): string {
	if (type === 'sign_petition') return defaultText;
	if (type === 'view_petition') return 'View petition';
	return text ?? '';
}

function getCtaHref(type: string, link: string | undefined): string {
	if (type === 'sign_petition' || type === 'view_petition') return '#';
	return link ?? '#';
}

export const CtaButton: React.FC<CtaProps> = ({ type, text, link, style, defaultText }) => {
	if (!type || type === 'hidden') return <div style={{ height: 24 }} />;
	if (type === 'custom' && (!text || !link)) return <div style={{ height: 24 }} />;

	const isPrimary = type === 'sign_petition' || (type === 'custom' && style === 'primary_cta');
	const label = getCtaLabel(type, text, defaultText);
	const href = getCtaHref(type, link);

	return (
		<div style={{ textAlign: 'center', padding: '12px 0' }}>
			<span
				style={{
					display: 'block',
					padding: '16px 24px',
					backgroundColor: isPrimary ? C.primaryBtn : C.white,
					color: C.text,
					fontFamily: C.font,
					fontSize: 18,
					fontWeight: 700,
					textDecoration: 'none',
					borderRadius: 8,
					border: `1px solid ${isPrimary ? C.primaryBtn : C.muted}`,
					boxSizing: 'border-box',
					cursor: 'default',
				}}
			>
				{label || href}
			</span>
		</div>
	);
};
